// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SavedSearchCta_wrapper__PqLTh"};